import React from "react";
import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";

import { usePublicDocumentTitle } from "@src/hooks/useDocumentTitle";
import { PublicPageRoutes } from "@src/routes/public/public-page-routes";

const routes: RouteObject[] = [...PublicPageRoutes];

const router = createBrowserRouter(routes);

export const PublicRoutes = () => {
  usePublicDocumentTitle();
  return <RouterProvider router={router} />;
};
